<template>
  <div class="ui-loader" :class="{show: visible}">
      <p class="loader"></p>
      <span v-if="text">{{text}}</span>
  </div>
</template>

<script>
  export default {
    props: [
      'text',
      'visible'
    ],
    data() {
      return {

      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  .ui-loader {
    position: absolute;
    z-index: 99;
    top: 50%;
    left: 50%;
    margin: -3rem 0 0 -3rem;
    background-color: rgba(0, 0, 0, .9);
    border-radius: 1rem;
    padding: 1.5rem;
    text-align: center;
    display: none;
    animation: uiLoader 300ms;
    &.show {
      display: block;
    }
    span {
      margin-top: .5rem;
      display: block;
      color: #fff;
      font-size: 1.2rem;
    }
  }
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 2.4rem;
    height: 2.4rem;
  }
  .loader {
    margin: 0 auto;
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    border-top: .4rem solid rgba(255, 255, 255, 0.2);
    border-right: .4rem solid rgba(255, 255, 255, 0.2);
    border-bottom: .4rem solid rgba(255, 255, 255, 0.2);
    border-left: .4rem solid #ffffff;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: loaderAnimation 1.1s infinite linear;
    animation: loaderAnimation 1.1s infinite linear;
  }
  @-webkit-keyframes loaderAnimation {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes loaderAnimation {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes uiLoader {
    from {
      opacity: 0;
      transform: scale(.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/loader.vue